import * as React from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { clsx } from 'clsx';

import * as styles from './HeadCategoryLink.css';

interface IHeadCategoryLinkProps {
  children: string;
  href: string;
  iconUrl: string;
  allCategory: boolean;
  onClick?(): void;
}

export const HeadCategoryLink: React.FC<IHeadCategoryLinkProps> = ({
  children,
  href,
  iconUrl,
  allCategory,
  onClick,
}) => {
  return (
    <a
      className={clsx(styles['link'], { [styles['all-category']]: allCategory })}
      href={href}
      onClick={onClick}
      data-testid="HeadCategoryLink"
    >
      <div
        style={{ backgroundImage: `url(${iconUrl})` }}
        className={styles['icon']}
        data-testid="HeadCategoryLinkIcon"
      />
      <div className={styles['text']}>
        <TruncateMarkup lines={2}>
          <div>{children}</div>
        </TruncateMarkup>
      </div>
    </a>
  );
};
